<div class="password-view">
  <div class="password-view__control">
    <input type="text" class="password-view__control__input" id="code" #code autocomplete="off" />
  </div>

  <frodo-numeric-keyboard
    [viewType]="viewType"
    side="FRONT"
    (codeSubmitted)="passwordSubmit.emit($event)"
  ></frodo-numeric-keyboard>
</div>
